import { Component, Input } from '@angular/core';
import { IFlatRateInstructionTotal, TotalOfTotals } from '../../time-sheets.type';

@Component({
	selector: 'app-instruction-totals',
	styleUrls: ['./totals.styles.scss'],
	template: `
		<div *ngIf="totals && totals.length > 0">
			<br />
			<h5 fxLayoutAlign="center center" class="mt-0">{{ title }}</h5>
			<table mat-table [dataSource]="totals" class="totals-table">
				<ng-container matColumnDef="label">
					<th mat-header-cell class="header" *matHeaderCellDef>Instruction</th>
					<td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
				</ng-container>

				<ng-container matColumnDef="totalNumber">
					<th mat-header-cell class="header" *matHeaderCellDef>Hours</th>
					<td mat-cell *matCellDef="let element">
						<span *ngIf="element.hours">{{ element.hours | hoursMinutes }}</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="rate">
					<th mat-header-cell class="header" *matHeaderCellDef>Rate</th>
					<td mat-cell *matCellDef="let element">
						<span *ngIf="element.payRate">{{ element.payRate | currency }}</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="total">
					<th mat-header-cell class="header" *matHeaderCellDef>Total</th>
					<td mat-cell *matCellDef="let element">{{ element.totalDollars | currency }}</td>
				</ng-container>

				<tr class="header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr class="table-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</div>
		<div *ngIf="totalOfTotals" class="totals-table">
			<div class="row">
				<div class="column1 total-header padding-top-5">&nbsp;</div>
				<div class="column2 total-header padding-top-5">Total</div>
			</div>
			<div class="row">
				<div class="column1">Total</div>
				<div class="column2">{{ totalOfTotals.total | currency }}</div>
			</div>
		</div>
	`
})
export class InstructionTotalsComponent {
	@Input() title: string;
	@Input() totals: IFlatRateInstructionTotal[];
	@Input() totalOfTotals: TotalOfTotals;
	displayedColumns: string[] = ['label', 'totalNumber', 'rate', 'total'];
}
